import React from 'react';
import {
    CMS_ALL_GAMES,
    CMS_MATH_GAMES,
    CMS_ELA_GAMES,
    PARENT_PATH,
    CMS_ALL_WORKSHEETS,
    CMS_MATH_WORKSHEETS,
    CMS_ELA_WORKSHEETS

} from '../../../routes/route-paths';
import styled from 'styled-components';
import { white, indigo, deepCoveDark, royal, whiteLilac } from '../shared-styles/Colors';
import { trackToGtmFE } from '../../../utils/gtm-event-common';

const EduLink = styled.li`
  cursor: pointer;
  // border-bottom: solid 0.1rem ${whiteLilac};
  text-align: left;
  & > a {
    background-color: ${(props) => (props.theme.white ? white : deepCoveDark)};;
    color: ${(props) => (props.theme.white ? deepCoveDark : white)};
    padding: 1rem 2.2rem;
    display: inline-block;
    width: 20.0rem;
    & :hover {
      background-color: ${(props) => (props.theme.white ? whiteLilac : royal)};
      text-decoration: none;
      color: ${(props) => (props.theme.white ? indigo : white)};
    }
  }
  @media screen and (max-width:1279px){
    padding-bottom:1.6rem;
    &:first-child{
       padding-top:1.3rem;
     }
  }
`;

const handleOnClickEvent = (e,name,pathname) => {
  e.stopPropagation();
  trackToGtmFE('clicked_navigation',{'Click Text': name, 'Click URL': pathname});
  typeof trackEventOnGA != "undefined" && trackEventOnGA(name, 'Clicked', 'from: Global Header')
}
const CurriculumMenu = React.memo(() => {

  return (

    <ul className={`header-curriculum-menu-wrapper header-curriculum-menu-wrapper-white-theme`}>
      <EduLink className="edu-link">
        <a href={PARENT_PATH}  onClick={(e) => {handleOnClickEvent(e,'How It works',PARENT_PATH)}} className="edu-link-a">
          How It works
        </a>
      </EduLink>
      <EduLink className="edu-link">
        <a href={CMS_ALL_GAMES}  onClick={(e) => {handleOnClickEvent(e,'All Games', CMS_ALL_GAMES)}} className="edu-link-a">
          All Games
        </a>
      </EduLink>
      <EduLink className="edu-link">
        <a href={CMS_MATH_GAMES}  onClick={(e) => {handleOnClickEvent(e,'Math Games',CMS_MATH_GAMES)}} className="edu-link-a">
          Math Games
        </a>
      </EduLink>
      <EduLink className="edu-link">
        <a href={CMS_ELA_GAMES}  onClick={(e) => {handleOnClickEvent(e,'ELA Games', CMS_ELA_GAMES)}} className="edu-link-a">
          ELA Games
        </a>
      </EduLink>
      <EduLink className="edu-link">
        <a href={CMS_ALL_WORKSHEETS}  onClick={(e) => {handleOnClickEvent(e,'All Worksheets', CMS_ALL_WORKSHEETS)}} className="edu-link-a">
          All Worksheets
        </a>
      </EduLink>
      <EduLink className="edu-link">
        <a href={CMS_MATH_WORKSHEETS}  onClick={(e) => {handleOnClickEvent(e,'Math Worksheets',CMS_MATH_WORKSHEETS )}} className="edu-link-a">
          Math Worksheets
        </a>
      </EduLink>
      <EduLink className="edu-link">
        <a href={CMS_ELA_WORKSHEETS}  onClick={(e) => {handleOnClickEvent(e,'ELA Worksheets', CMS_ELA_WORKSHEETS)}} className="edu-link-a">
          ELA Worksheets
        </a>
      </EduLink>

    </ul>
  );
});

export default CurriculumMenu;
